import { ViewStyle } from 'react-native';
import {ReactNode} from "react";

export enum ButtonColor {
  BLUE = 'blue',
  BLUE_LIGHT = 'blueLight',
  DARK_BLUE = 'darkBlue',
  GREEN = 'green',
  YELLOW = 'yellow',
  RED = 'red',
  GRAY = 'gray',
  WHITE = 'white',
}

export enum ButtonSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  BIG = 'big',
}

export enum IconType {
  ARROW_DOWN = 'arrow_down',
  ARROW_UP = 'arrow_up',
  ARROW_RIGHT = 'arrow_right',
  PLUS = 'plus',
  FILTER = 'filter',
  PENCIL = 'pencil',
  UPLOAD = 'upload',
}

export type OnClickFunc = () => Promise<void> | void;


export interface ButtonProps {
  text: ReactNode;
  loadingText?: string;
  onClick?: OnClickFunc;
  isDisabled?: boolean;
  customClass?: string;
  elementRef?: any;
  color?: ButtonColor;
  size?: ButtonSize;
  iconType?: IconType;
  isFlat?: boolean;
  isFilled?: boolean;
  title?: string;
  isSubmitButton?: boolean,
  testId?: string
  style?: ViewStyle;
  className?: string
}

export interface ButtonLayoutProps {
  text: ReactNode;
  loadingText?: string;
  onClick?: OnClickFunc;
  isDisabled?: boolean;
  customClass?: string;
  elementRef?: any;
  color?: ButtonColor;
  size?: ButtonSize;
  iconType?: IconType;
  isFlat?: boolean;
  isFilled?: boolean;
  title?: string;
  isSubmitButton?: boolean,
  isLoading: boolean
  testId?: string
  style?: ViewStyle,
  className?: string
  image?: ReactNode;
}
